window.oneClickOrder = Vue.component('one-click-order', {
    props: ['productid'],
    created() {
        this.form.product_id = this.productid;
    },
    data() {
        return {
            sent: false,
            form: {
                name: '',
                phone: '',
                product_id: '',
            },
            message: '',
            successMessage: '',
        }
    },
    methods: {
        submit(e) {
            e.preventDefault();
            this.message = '';
            this.successMessage = '';
            axios.post('/cart/one-click-order', this.form).then(response => {
                if (response.data.success) {
                    this.sent = true;
                    this.form.name = '';
                    this.form.phone = '';
                    this.successMessage = 'Ваш заказ успешно принят, ожидайте звонка менеджера';
                } else {
                    this.message = response.data.message;
                }
            });
        }
    }
})
